var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimerView',{key:"timeradmin",attrs:{"id":_vm.id,"admin-mode":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }